import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography, TypographyPDL } from '../../../theme/Typography.es.js';
import '../../../theme/ZinniaStylesReset.es.js';

const Styles = labelStyles("Badge", {
  root: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: var(--zds-size-small, 26px);
    min-width: var(--zds-size-small, 24px);
    padding: var(--zds-space-2, 3px) var(--zds-space-8, 8px);
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    ${Typography.base};

    border-radius: var(--zds-radius-pill, 100px);
    ${TypographyPDL("--zds-small-print-2", "smallPrint1Bold")}

    &[data-color='gray'] {
      background-color: var(--zds-gray-warm-9, ${Colors.neutral700});
      color: var(--zds-text-inverted, ${Colors.neutral100});
    }

    &[data-color='white'] {
      background-color: var(--zds-prime-white, ${Colors.neutral100});
      color: var(--zds-text-stronger, ${Colors.neutral800});
    }

    &[data-color='info'] {
      background-color: var(--zds-ui-primary-weaker, ${Colors.blue10});
      color: var(--zds-text-stronger, ${Colors.neutral800});
    }

    &[data-color='info-bold'] {
      background-color: var(--zds-ui-primary-strongest, ${Colors.blue});
      color: var(--zds-text-inverted, ${Colors.neutral100});
    }

    &[data-color='success'] {
      background-color: var(--zds-status-success-weaker, ${Colors.success100});
      color: var(--zds-text-default, ${Colors.neutral800});
    }

    &[data-color='warning'] {
      background-color: var(--zds-status-warning-weaker, ${Colors.warning100});
      color: var(--zds-text-default, ${Colors.neutral800});
    }

    &[data-color='error'] {
      background-color: var(--zds-status-error-weaker, ${Colors.error100});
      color: var(--zds-text-default, ${Colors.neutral800});
    }

    &[data-color='error-bold'] {
      background-color: var(--zds-status-error-stronger, ${Colors.error400});
      color: var(--zds-text-inverted, ${Colors.neutral100});
    }
  `
});
const Badge = ({ className, color = "gray", children }) => {
  return jsx("span", { className, css: Styles.root, "data-color": color, "data-zds": true }, children);
};

export { Badge };
//# sourceMappingURL=Badge.es.js.map
